import { twipsPerPixel } from '@app/utils/measurement';

export const getImg2StickerRatio = ({ shape, width: panelWidth, height: panelHeight }, stickerImg, artworkImgName) => {
  if (shape !== 'polygon') return 1;
  if (!stickerImg || !stickerImg.width || !stickerImg.height) return 1;

  const { source, width: imgWidth, height: imgHeight } = stickerImg;
  if (source !== artworkImgName) return 1;

  return Math.max(imgWidth / panelWidth, imgHeight / panelHeight, 1);
};

export const getCustomStickerImgSize = (master, stickerImg, artworkImgName, { width: origImgWidth, height: origImgHeight }, { width: stickerWidth, height: stickerHeight }, keepAspect, ppi) => {
  if (!stickerWidth && !stickerHeight) {
    return {
      width: origImgWidth * twipsPerPixel(ppi),
      height: origImgHeight * twipsPerPixel(ppi),
    }
  }
  const img2StickerRatio = getImg2StickerRatio(master, stickerImg, artworkImgName);
  stickerWidth *= img2StickerRatio;
  stickerHeight *= img2StickerRatio;

  const imgAspect = origImgWidth / origImgHeight;

  return {
    width: keepAspect && imgAspect <= 1 ? stickerHeight * imgAspect : stickerWidth,
    height: keepAspect && imgAspect > 1 ? stickerWidth / imgAspect : stickerHeight,
  }
};

export const getCustomStickerSize = ({ width: stickerWidth, height: stickerHeight }, { width: shapeWidth, height: shapeHeight }, keepAspect) => {
  if (!stickerWidth && !stickerHeight) {
    return {
      width: shapeWidth,
      height: shapeHeight,
    }
  }
  const shapeAspect = shapeWidth / shapeHeight;
  return {
    width: keepAspect && shapeAspect <= 1 ? stickerHeight * shapeAspect : stickerWidth,
    height: keepAspect && shapeAspect > 1 ? stickerWidth / shapeAspect : stickerHeight,
  }
};